import styled from 'styled-components'

export const RadioGroup = styled.div`
    margin-bottom: 40px;
    position: relative;

    ul > li {
        display: inline-block;
        padding-right: 24px;
    }

    .error {
        color: #e51a45 !important;
    }

    .error-message {
        font-size: 0.75rem;
        position: absolute;
        left: 1rem;
        margin-top: 0.225rem;
    }
`

export const TextWithButton = styled.div`
    display: flex;
    align-items: center;

    .title {
        font-weight: 600;
    }
`
